export default [
  {
    title: 'Inicio',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: 'Configuracion',
    route: 'second-page',
    icon: 'FileIcon',
  },
  {
    title: 'Eventos',
    route: 'second-page',
    icon: 'FileIcon',
  },
]
